import React from 'react';
import { Navigate } from 'react-router-dom';
import { authService } from '../lib/auth';

const ProtectedRoute = ({ children, allowedRoles, requiredModule }) => {
  const user = authService.getCurrentUser();
  const isAuthenticated = authService.isAuthenticated();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles) {
    const roleMatch = allowedRoles.includes(user?.role?.toLowerCase());
    const moduleMatch = requiredModule && user?.module_access?.includes(requiredModule);
    if (!roleMatch && !moduleMatch) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;